import type { SessionOutcome } from './types';

export const CALLBACK_PATH = '/auth/callback';
export const LOGOUT_PATH = '/logout';
export const DENIED_PATH = '/auth/denied';

export const DENIED_SOURCE_PARAM = 'source';
export const DENIED_CODE_PARAM = 'code';

// Query parameters Cognito's hosted UI appends to the callback redirect.
export const CALLBACK_CODE_PARAM = 'code';
export const CALLBACK_STATE_PARAM = 'state';
export const CALLBACK_ERROR_PARAM = 'error';

export function buildDeniedUrl(refusal: Extract<SessionOutcome, { kind: 'terminal' }>): string {
  const query = new URLSearchParams({
    [DENIED_SOURCE_PARAM]: refusal.source,
    [DENIED_CODE_PARAM]: refusal.code,
  });
  return `${DENIED_PATH}?${query.toString()}`;
}

export function callbackCarriesPayload(search: string): boolean {
  const params = new URLSearchParams(search);
  return Boolean(params.get(CALLBACK_CODE_PARAM)) || Boolean(params.get(CALLBACK_ERROR_PARAM));
}
